// extracted by mini-css-extract-plugin
var _1 = "eTU55SP8Sl2r4Br_VxqQ";
var _2 = "eTU55SP8Sl2r4Br_VxqQ";
var _3 = "xvN5HI6d5YkyOBeisOie";
var _4 = "xvN5HI6d5YkyOBeisOie";
var _5 = "DW3RoA7Lc6rmSzsQg66D";
var _6 = "DW3RoA7Lc6rmSzsQg66D";
var _7 = "gBOD3PTRHRu0fBDDS97l";
var _8 = "gBOD3PTRHRu0fBDDS97l";
export { _1 as "add-education-button", _2 as "addEducationButton", _3 as "form-bottom-margin", _4 as "formBottomMargin", _5 as "modal-container", _6 as "modalContainer", _7 as "no-bottom-padding", _8 as "noBottomPadding" }
